<template>
  <section class="inventory--part-details animated fadeIn">
    <part-details-stock-label ref="stockLabel"></part-details-stock-label>

    <b-card v-if="!buttonsHeaderVisible" class="buttonHeader">
      <div>
        <b-button
          @click="redirectToList"
          size="sm"
          class="cancelButton"
        >Back to list</b-button>
        <b-button
          variant="primary"
          @click="() => updateInventory(partDetails)"
          size="sm"
        >Save</b-button>
      </div>
    </b-card>

    <b-row id="buttonHeader" class="justify-content-between ml-1 mr-3 mt-1">
      <div class="inventory--part-details--buttons">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="$refs.stockLabel.print()">
          <i class="fa fa-tag" aria-hidden="true"></i>
          Print stock label
        </b-button>
      </div>

      <div class="inventory--part-details--actions">
        <b-button
          @click="redirectToList"
          size="sm"
        >Back to list</b-button>
        <b-button
          variant="primary"
          @click="() => updateInventory(partDetails)"
          size="sm"
        >Save</b-button>
      </div>
    </b-row>

    <b-row>
      <!-- Details column -->
      <b-col cols="9">
        <b-row>
          <b-col cols="9">
            <b-row>
              <b-col>
                <div class="inventory--part-details--header">
                  <div>
                    <h5>{{ partDetails.partNumber }}</h5>
                  </div>

                  <!-- @todo: Add details when API will be ready -->
                  <div class="inventory--part-details--boxes">
                    <div class="inventory--part-details--box">
                      <span>In Stock</span>
                      -
                    </div>
                    <div class="inventory--part-details--box">
                      <span>Allocated</span>
                      -
                    </div>
                    <div class="inventory--part-details--box">
                      <span>Available</span>
                      -
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="SKU">
                  <b-form-input v-model="partDetails.sku" type="text" size="sm"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Category">
                  <lookup-dropdown
                    label="category"
                    moduleName="categories"
                    resource="inventoryCategory"
                    propKey="inventoryCategoryId"
                    :value="partDetails.inventoryCategoryId"
                    :options="categories"
                    @change="onValueChange"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Class">
                  <lookup-dropdown
                    label="class"
                    moduleName="classes"
                    resource="inventoryClass"
                    propKey="inventoryClassId"
                    :value="partDetails.inventoryClassId"
                    :options="classes"
                    @change="onValueChange"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Manufacturer">
                  <lookup-dropdown
                    label="manufacturer"
                    moduleName="manufacturers"
                    resource="inventoryManufacturer"
                    propKey="manufacturerId"
                    :value="partDetails.manufacturerId"
                    :options="manufacturers"
                    @change="onValueChange"
                  />
                </b-form-group>

              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="UoM">
                  <lookup-dropdown
                    label="UoM"
                    moduleName="uoms"
                    resource="inventoryUom"
                    propKey="uoMId"
                    :value="partDetails.uoMId"
                    :options="uoms"
                    @change="onValueChange"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Packaging">
                  <lookup-dropdown
                    label="packaging"
                    moduleName="packaging"
                    resource="inventoryPackaging"
                    propKey="packageId"
                    :value="partDetails.packageId"
                    :options="packaging"
                    @change="onValueChange"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Piece / Pkg">
                  <b-form-input v-model="partDetails.piecePerPkg" type="number" size="sm"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Lead free">
                  <b-form-select v-model="partDetails.leadFree" id="leadFree" size="sm">
                    <option
                      v-for="(value) in leadFreeValues"
                      v-bind:key="value"
                      v-bind:value="value"
                    >{{value}}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="3">
            <h6 class="inline-header">Other identifiers</h6>
            <b-form-group label="NSN number">
              <b-form-input v-model="partDetails.nsnNumber" type="text" size="sm"></b-form-input>
            </b-form-group>
            <b-form-group label="Harmonized code">
              <b-form-input v-model="partDetails.harmonizedCode" type="text" size="sm"></b-form-input>
            </b-form-group>
            <b-form-group label="Alt number">
              <b-form-input v-model="partDetails.altNumber" type="text" size="sm"></b-form-input>
            </b-form-group>
            <b-form-group label="Internal PN">
              <b-form-input v-model="partDetails.internalPN" type="text" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Description">
              <b-form-textarea v-model="partDetails.description" rows="3"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Other specs">
              <b-form-input v-model="partDetails.specs" type="text" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Comments">
              <b-form-textarea v-model="partDetails.comments" rows="3"></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Non conforming materials">
              <b-form-textarea v-model="partDetails.ncmReport" rows="3"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <!-- Cost / discount column -->
      <b-col cols="3" class="bordered-left">
        <b-row>
          <b-col>
            <h6 class="inline-header">Cost / resale</h6>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group label="Cost">
              <b-form-input v-model="partDetails.cost" type="text" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="8">
            <b-form-group label="Expense account">
              <b-form-select v-model="partDetails.expenseAccountId" size="sm">
                <option
                  v-for="(account) in sortSelect(expenseAccounts)"
                  v-bind:key="account.id"
                  v-bind:value="account.id"
                >{{account.name}}</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group label="List price">
              <b-form-input v-model="partDetails.listPrice" type="text" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="8">
            <b-form-group label="Asset account">
              <b-form-select v-model="partDetails.assetAccountId" size="sm">
                <option
                  v-for="(account) in sortSelect(assetAccounts)"
                  v-bind:key="account.id"
                  v-bind:value="account.id"
                >{{account.name}}</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group label="Resale">
              <b-form-input v-model="partDetails.resale" type="text" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="8">
            <b-form-group label="Income account">
              <b-form-select v-model="partDetails.incomeAccountId" size="sm">
                <option
                  v-for="(account) in sortSelect(incomeAccounts)"
                  v-bind:key="account.id"
                  v-bind:value="account.id"
                >{{account.name}}</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <inventory-list
      :partId="partId"
      :gridId="gridId"/>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import InventoryList from '@/shared/components/InventoryList';
import { createScroll, destroyScroll, isElementInView } from '@/shared/scroll'
import { LEAD_FREE_VALUES } from '@/shared/constants';
import { GRID_ID } from '@/shared/constants';

import PartDetailsStockLabel from './components/StockLabel';

export default {
  name: 'PartDetails',
  components: {
    PartDetailsStockLabel,
    InventoryList,
  },
  data() {
    return {
      buttonsHeaderVisible: true,
      leadFreeValues: LEAD_FREE_VALUES,
      gridId: GRID_ID.PART_DETAILS_INVENTORY_LIST,
    }
  },
  computed: {
    partId() {
      return this.$route.params.partId;
    },
    ...mapGetters('inventoryDetails', ['partDetailsById']),
    partDetails() {
      return this.partDetailsById(this.partId)
    },
    ...mapGetters('lookup', [
      'classes',
      'categories',
      'manufacturers',
      'assetAccounts',
      'expenseAccounts',
      'incomeAccounts',
      'conditions',
      'uoms',
      'packaging',
    ]),
  },
  methods: {
    ...mapActions('inventoryDetails', ['updateInventory']),
    redirectToList() {
      this.$router.push({ name: 'inventory.list' });
    },
    onValueChange({ name, value }) {
      this.partDetails[name] = value;
    },
    handleScroll () {
      this.buttonsHeaderVisible = isElementInView(document.getElementById('buttonHeader'));
    },
  },
  created() {
    createScroll(this);
  },
  destroyed() {
    destroyScroll(this);
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

.inventory--part-details {
  &--header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid $lightGray;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 20px;

    h5 {
      margin-bottom: 0;
    }
  }

  &--boxes {
    display: flex;
  }

  &--box {
    text-align: center;
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
    border: 1px solid $lightGray;
    border-radius: 5px;
    padding: 2rem;

    span {
      display: block;
      font-size: 12px;
      color: $mutedGray;
      font-weight: bold;
    }
  }

  &--buttons,
  &--actions {
    .btn + .btn {
      margin-left: 10px;
    }
  }

  &--buttons {
    margin-bottom: 10px;
  }

  &--actions {
    margin-bottom: 10px;
  }

  .form-text {
    font-weight: bold;
  }

  .inline-header {
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px solid $dirtyWhite;
    color: $mutedGray;
    font-weight: bold;

    &.margin-top {
      margin-top: 20px;
    }
  }

  .bordered-left {
    border-left: 1px solid $dirtyWhite;
  }

  .buttonHeader {
    position: fixed;
    top: 15%;
    left: 80%;
    z-index: 7;
  }

  .cancelButton {
    margin-right: 10px;
  }
}
</style>

